"use strict";
var SelectItem = (function () {
    function SelectItem(key, displayValue, canSelect) {
        this.key = key;
        this.displayValue = displayValue;
        this.canSelect = canSelect;
    }
    return SelectItem;
}());
exports.SelectItem = SelectItem;
//# sourceMappingURL=D:/a/1/s/eligibility/src/rules/models/select-item.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/rules/models/select-item.model.js